import { useState, useEffect } from 'react';

function useLocalStorage(key, initialValue, needParseValue = true) {
  const [state, setState] = useState(() => {
    const storedValue = localStorage.getItem(key);
    if (storedValue === null || storedValue === 'undefined' || typeof storedValue === 'undefined') return initialValue;
    if (needParseValue) {
      try {
        return JSON.parse(storedValue);
      } catch (e) {
        console.error('Parsing error on retrieving item from localStorage', e);
        return initialValue;
      }
    } else {
      if (storedValue === 'true') return true;
      else if (storedValue === 'false') return false;
      else return storedValue;
    }
  });

  useEffect(() => {
    if (state === null) {
      localStorage.removeItem(key);
    } else {
      const valueToStore = needParseValue ? JSON.stringify(state) : state;
      localStorage.setItem(key, valueToStore);
    }
    // eslint-disable-next-line
  }, [state]);

  return [state, setState];
}

export default useLocalStorage;
